import script from "./CampaignDashboardPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignDashboardPanel.vue?vue&type=script&setup=true&lang=js"

import "./CampaignDashboardPanel.vue?vue&type=style&index=0&id=bba145b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bba145b2"]])

export default __exports__